export default {
    type:'',
    data:{},
    error:'',
    isAuthenticated:false
}